import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SharedConfig } from '@takectrl-multiapp/svcs-share-config';
declare const dataLayer: unknown[];

@Component({
  selector: 'emergency-empty-state',
  standalone: false,
  templateUrl: './emergency-empty-state.component.html',
  styleUrls: ['./emergency-empty-state.component.scss'],
})
export class EmergencyEmptyStateComponent implements OnInit {
  constructor(
    public sharedConfig: SharedConfig
  ) {}

  ngOnInit(): void {
    dataLayer.push({
      event: 'page_show',
      screenPath: 'emergency-empty-state',
      screenName: 'emergency-empty-state',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  async ngAfterViewInit(): Promise<void> {}
}
